import types from '../types'

const initialState = {
  isFetching: false,
  iss: null,
  launch: null,
  authorizeUrl: null,
  tokenUrl: null,
  userFriendlyStatus: 'Waiting...',
  redirectToTokenUri: false,
  error: null,
  tokenURI: null,
  accessTokenRecieved: false,
  epicVersion: ''
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
  case types.FHIR_SMART_INITIALIZE:
    return {
      ...state,
      iss: action.iss,
      launch: action.launch,
      userFriendlyStatus: 'Initializing...'
    }
  case types.FHIR_SET_ISSUER:
    return {
      ...state,
      iss: action.iss
    }
  case types.FHIR_ERROR:
    return {
      ...state,
      error: {
        code: action.code,
        description: action.description
      }
    }
  case types.FHIR_GET_METADATA:
    return {
      ...state,
      isFetching: true,
      userFriendlyStatus: 'Fetching metadata...'
    }
  case types.FHIR_GET_METADATA_SUCCEEDED:
    return {
      ...state,
      isFetching: false,
      authorizeUrl: action.authorizeUrl,
      tokenUrl: action.tokenUrl,
      redirectToTokenUri: true,
      userFriendlyStatus: 'Redirecting...',
      epicVersion: action.epicVersion,
      error: null
    }
  case types.FHIR_GET_METADATA_FAILED:
    return {
      ...state,
      isFetching: false,
      error: action.error
    }
  case types.FHIR_ACCESS_TOKEN_RECEIVED: {
    return {
      ...state,
      isFetching: false,
      userFriendlyStatus: 'Access token received...',
      error: null,
      accessTokenRecieved: true
    }
  }
  case types.FHIR_GET_DATA:
    return {
      ...state,
      userFriendlyStatus: 'Getting data...'
    }
  case types.FHIR_GENERATE_TOKEN_URI_REQUESTED: {
    return {
      ...state,
      isFetching: true,
      tokenURI: null
    }
  }
  case types.FHIR_GENERATE_TOKEN_URI_FULFILLED: {
    return {
      ...state,
      isFetching: false,
      tokenURI: action.payload
    }
  }
  case types.FHIR_GENERATE_TOKEN_URI_REJECTED: {
    return {
      ...state,
      isFetching: false,
      error: action.error
    }
  }
  default:
    return state
  }
}

export default authReducer
